/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import { NotificationCategoryFragmentDoc } from '../../../graphql/fragments/NotificationCategory.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetUserNotificationPreferencesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserNotificationPreferencesQuery = {
  readonly __typename?: 'Query';
  readonly getUserNotificationPreferences:
    | {
        readonly __typename: 'NotificationPreferencesError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'UserNotificationPreferences';
        readonly notificationCategories: ReadonlyArray<{
          readonly __typename: 'NotificationCategory';
          readonly id: string;
          readonly displayName: string;
          readonly emailSubscribe: boolean;
          readonly pushSubscribe: boolean;
          readonly hasResolved: boolean;
        }>;
      };
};

export const GetUserNotificationPreferencesDocument = gql`
  query GetUserNotificationPreferences {
    getUserNotificationPreferences {
      __typename
      ... on NotificationPreferencesError {
        errorMessage
        __typename
      }
      ... on UserNotificationPreferences {
        notificationCategories {
          ...notificationCategory
        }
      }
      ... on UserError {
        errorMessage
        __typename
      }
    }
  }
  ${NotificationCategoryFragmentDoc}
`;

export function useGetUserNotificationPreferencesQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetUserNotificationPreferencesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetUserNotificationPreferencesQuery,
    GetUserNotificationPreferencesQueryVariables
  >({ query: GetUserNotificationPreferencesDocument, ...options });
}
